import { getListName } from 'analytics/enhanced-ecommerce'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'

type TripPlannerOfferListSurface =
  | 'hotelChatCarousel'
  | 'experienceChatCarousel'
  | 'cruiseChatCarousel'
  | 'hotelSearchDrawer'
  | 'experienceSearchDrawer'
  | 'experienceThingsToDoTab'

const OFFER_LIST_TRACKING_CONFIG: Record<
  TripPlannerOfferListSurface,
  { listName: string; source: string }
> = {
  hotelChatCarousel: {
    listName: getListName('TripPlanner', 'Chat Trip Planner', 'hotel-carousel'),
    source: 'trip_planner_hotel_chat_carousel',
  },
  experienceChatCarousel: {
    listName: getListName('TripPlanner', 'Chat Trip Planner', 'experience-carousel'),
    source: 'trip_planner_experience_chat_carousel',
  },
  cruiseChatCarousel: {
    listName: getListName('TripPlanner', 'Chat Trip Planner', 'cruise-carousel'),
    source: 'trip_planner_cruise_chat_carousel',
  },
  hotelSearchDrawer: {
    listName: getListName('TripPlanner', 'Chat Trip Planner', 'hotel-search-drawer'),
    source: 'trip_planner_hotel_search_drawer',
  },
  experienceSearchDrawer: {
    listName: getListName('TripPlanner', 'Chat Trip Planner', 'experience-search-drawer'),
    source: 'trip_planner_experience_search_drawer',
  },
  experienceThingsToDoTab: {
    listName: getListName('TripPlanner', 'Chat Trip Planner', 'experience-things-to-do-tab'),
    source: 'trip_planner_experience_things_to_do_tab',
  },
}

export default function useTripPlannerOfferListTracking(
  surface: TripPlannerOfferListSurface,
  trackingKey: string,
): App.OfferListTrackingConfig {
  const { listName, source } = OFFER_LIST_TRACKING_CONFIG[surface]

  return useOfferListTracking(listName, {
    key: trackingKey,
    source,
  })
}
